import { createReducer } from "../../common/reduxUtil";
import {
  PROGRAM_TO_UPDATE,
  SHORTLIST_CANDIDATE,
  SHOW_PROGRAM_UPDATE_MODAL,
  SHOW_AI_CHAT,
  AI_CHAT_PROGRAM_CONTEXT,
  AI_CHAT_PLANNER_CONTEXT,
} from "./types";

const initialState = {
  shortListUser: null,
  programToUpdate: null,
  showProgramUpdateModal: false,
  showAiChat: false,
  aiChatProgramContext: null,
  aiChatPlannerContext: null,
};

export default createReducer(initialState, {
  [SHORTLIST_CANDIDATE]: (state, payload) => {
    return Object.assign({}, state, {
      shortListUser: payload,
    });
  },
  [PROGRAM_TO_UPDATE]: (state, payload) => {
    return Object.assign({}, state, {
      programToUpdate: payload,
    });
  },
  [SHOW_PROGRAM_UPDATE_MODAL]: (state, payload) => {
    return Object.assign({}, state, {
      showProgramUpdateModal: payload,
    });
  },
  [SHOW_AI_CHAT]: (state, payload) => {
    return Object.assign({}, state, {
      showAiChat: payload,
    });
  },
  [AI_CHAT_PROGRAM_CONTEXT]: (state, payload) => {
    return Object.assign({}, state, {
      aiChatProgramContext: payload,
    });
  },
  [AI_CHAT_PLANNER_CONTEXT]: (state, payload) => {
    return Object.assign({}, state, {
      aiChatPlannerContext: payload,
    });
  },
});
